import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useKycSchema = () => {
  const { t } = useTranslate()

  const schema = z.object({
    nationalCode: z
      .string({
        required_error: t('kyc_validation_nationalCode_required'),
      })
      .min(10, {
        message: t('kyc_validation_nationalCode_length'),
      })
      .max(10, {
        message: t('kyc_validation_nationalCode_length'),
      }),
    year: z
      .string({
        required_error: t('kyc_validation_birthDate_required'),
      })
      .min(4, {
        message: t('kyc_validation_birthDate_required'),
      })
      .max(4, {
        message: t('quickKyc_validation_birthDate_4digit'),
      })
      .refine(
        (val) => {
          const year = parseInt(val)
          return year >= 1300 && year <= 1400
        },
        {
          message: t('quickKyc_validation_birthDate_range'),
        },
      ),
    month: z
      .string({
        required_error: t('kyc_validation_birthDate_required'),
      })
      .nonempty({
        message: t('kyc_validation_birthDate_required'),
      }),
    day: z
      .string({
        required_error: t('kyc_validation_birthDate_required'),
      })
      .nonempty({
        message: t('kyc_validation_birthDate_required'),
      }),
  })

  return { schema }
}
